<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7.99972 2.07031C8.33109 2.07031 8.59971 2.33894 8.59971 2.67031V7.40365H13.333C13.6644 7.40365 13.933 7.67227 13.933 8.00365C13.933 8.33502 13.6644 8.60364 13.333 8.60364H8.59971V13.337C8.59971 13.6683 8.33109 13.937 7.99972 13.937C7.66835 13.937 7.39972 13.6683 7.39972 13.337V8.60364H2.6664C2.33503 8.60364 2.06641 8.33502 2.06641 8.00365C2.06641 7.67227 2.33503 7.40365 2.6664 7.40365H7.39972V2.67031C7.39972 2.33894 7.66835 2.07031 7.99972 2.07031Z"
      :fill="color"
    />
  </svg>
  </template>
  
  <script>
  export default {
    name: 'PlusIcon',
    props: {
      width: {
        type: [String, Number],
        default: 16,
      },
      height: {
        type: [String, Number],
        default: 16,
      },
      color: {
        type: String,
        default: '#AAAAAA',
      },
    },
  };
  </script>
  
